import { useEffect } from "react";
import { Breadcrumb } from "~/types";

export function SectionBreadcrumb({ breadcrumb, emptyBreadcrumb}: {breadcrumb:any, emptyBreadcrumb:any}) {

    useEffect(() => {
      if (!breadcrumb) return;
      if(emptyBreadcrumb) localStorage.bdcb = JSON.stringify(breadcrumb);
      const noDuplicates = Array.isArray(breadcrumb) ? breadcrumb?.filter((bd, i) => breadcrumb.lastIndexOf(bd) == i) : undefined;
      if (noDuplicates?.length == 0) localStorage.bdcb = JSON.stringify(breadcrumb);
      else {
        if (noDuplicates) {
          try {
            let bdcb: Breadcrumb[] = JSON.parse(localStorage.bdcb);
            if (bdcb.findIndex(bc => bc.handle == noDuplicates[0].handle) == -1) localStorage.bdcb = JSON.stringify([...bdcb, noDuplicates[0]]);
          }
          catch {
            localStorage.bdcb = JSON.stringify([])
          }
        }
      }
    })
  
    return (
      <></>
    )
}